import { useState } from 'react';

export const usePagination = (filter: number, count: number, initialPage?: number) => {
	const [page, setPage] = useState<number | undefined>(initialPage);

	const gotoPage = (page: number) => setPage(page);

	return { page, gotoPage, pageCount: count ? Math.ceil(count / filter) : 0, filter };
};
